import { apiClient } from '../../lib/apiClient';
import type { BusinessRead, InvitePreviewRead } from '../../types/api';

function path(token: string): string {
  return `/api/v1/me/invites/${encodeURIComponent(token)}`;
}

/** GET /me/invites/{token}: what the link is for, before accepting. 404 unknown. */
export function fetchInvitePreview(
  token: string,
  signal?: AbortSignal,
): Promise<InvitePreviewRead> {
  return apiClient.get<InvitePreviewRead>(path(token), { signal });
}

/**
 * POST /me/invites/{token}/accept: joins the brand and returns it. 403
 * `INVITE_EMAIL_MISMATCH` when signed in as another address, 410
 * `INVITE_EXPIRED`, 409 `INVITE_ACCEPTED`.
 */
export function acceptInvite(token: string): Promise<BusinessRead> {
  return apiClient.post<BusinessRead>(`${path(token)}/accept`);
}
